<div class="drawer-header">
   <h4>Book Appointment</h4>
   <button
      class="v-button v-button-circle v-white v-graycolor"
      (click)="close()">
      <i class="icon fa fa-close"></i>
   </button>
</div>
<div class="bookingModal">
   Please select your RM,
   <span class="bookingName">{{ data.rmName }}</span>
   , from the dropdown list:
</div>
<iframe
   src="https://outlook.office365.com/owa/calendar/GrowthToolkitAppointment@vetcor.com/bookings/"
   width="100%"
   height="100%"
   frameborder="0"
   style="border: none; margin-top: -130px"></iframe>
